export const authenticationTypes = {
  SET_JWT_TOKEN: 'SET_JWT_TOKEN',
  SET_LOGGED_USER: 'SET_LOGGED_USER',
  SET_EXPIRE_TOKEN: 'SET_EXPIRE_TOKEN',
  SET_LOGGED_USER_EXPIRE: 'SET_LOGGED_USER_EXPIRE',
  SET_IS_AUTHENTICATED: 'SET_IS_AUTHENTICATED',
  SET_LOADED_ONCE: 'SET_LOADED_ONCE',
}
